import moment from 'moment'
import i18n from '@/locales'
import FetchLabel from '@/components/FetchLabel'
import { getRangeScopeOptionMap } from '@/utils/rangeScope'
import {
  COST_REPORT_PERIOD_TYPE_MAP,
  WEEK_DAY_MAP,
} from '../constants'

export const getSubscriptionProjectTableColumn = () => {
  return {
    field: 'project',
    title: i18n.t('report.subscription_scope'),
    slots: {
      default: ({ row }, h) => {
        if (!row.tenant && !row.project_domain) {
          return i18n.t('monitor.text00024')
        }
        const domain = row.project_domain || row.domain
        if (!row.tenant && domain) {
          return `${domain}${i18n.t('monitor.text00025')}`
        }
        if (row.tenant && domain) {
          return [
            <list-body-cell-wrap copy field='tenant' row={row} />,
            <list-body-cell-wrap hide-field copy field="domain" row={{ domain }}>
              <span class='text-weak'>{ domain }</span>
            </list-body-cell-wrap>,
          ]
        }
      },
    },
  }
}

export const getFrequencyTableColumn = () => {
  return {
    field: 'period_type',
    title: i18n.t('report.alert_frequency'),
    minWidth: 70,
    showOverflow: 'title',
    slots: {
      default: ({ row }, h) => {
        const utc = 0 - new Date().getTimezoneOffset() / 60
        const { colon_timer } = row
        let time
        if (colon_timer) {
          time = moment(moment().format('YYYY-MM-DD ') + colon_timer).add(utc, 'hours').format('HH:mm')
        }
        if (row.period_type === COST_REPORT_PERIOD_TYPE_MAP.month.key) {
          return i18n.t('report.subscription_cycle_type_month', [row.day, time])
        } else if (row.period_type === COST_REPORT_PERIOD_TYPE_MAP.one_time.key) {
          // return `${COST_REPORT_PERIOD_TYPE_MAP[row.period_type]?.value}`
          const date = moment(row.event_start_date).format('YYYY-MM-DD HH:mm')
          return `${COST_REPORT_PERIOD_TYPE_MAP[row.period_type]?.value} ${date}`
        } else if (row.period_type === COST_REPORT_PERIOD_TYPE_MAP.week.key) {
          return i18n.t('report.subscription_cycle_type_week', [WEEK_DAY_MAP[row.day].value, time])
          // return `${COST_REPORT_PERIOD_TYPE_MAP[row.period_type]?.value}${WEEK_DAY_MAP[row.day]?.value}${row.colon_timer}`
        } else if (row.period_type === COST_REPORT_PERIOD_TYPE_MAP.day.key) {
          return i18n.t('report.subscription_cycle_type_day', [time])
        }
        return `${COST_REPORT_PERIOD_TYPE_MAP[row.period_type]?.value}${row.colon_timer}`
      },
    },
  }
}

export const getSubjectTableColumn = ({ field = 'subject' } = {}) => {
  return {
    field,
    title: i18n.t('report.subscription_mail_subject'),
    minWidth: 70,
    showOverflow: 'title',
    slots: {
      default: ({ row }, h) => {
        return row[field] || 'Billing Report'
      },
    },
  }
}

export const getEmailsTableColumn = ({ field = 'user_ids', scope } = {}) => {
  return {
    field,
    title: i18n.t('common.notify_type.receiver'),
    minWidth: 70,
    showOverflow: 'title',
    slots: {
      default: ({ row }, h) => {
        if (row.user_ids) {
          return row.user_ids.map(v => {
            // fetch receipient by id
            const get_receiver = (resp) => {
              return resp.data.name + ' (' + resp.data.email + ')'
            }
            return <FetchLabel resource="receivers" id={v} version="v1" fetcher={get_receiver} params={{ scope }} />
          })
        }
        if (row.emails) {
          return row.emails.map(v => <div class='text-truncate'>{v}</div>)
        }
        return []
      },
    },
  }
}

export const getDataScopeTableColumn = ({ field = 'data_scope', vm = {} } = {}) => {
  return {
    field,
    title: i18n.t('common.billing_scope'),
    minWidth: 70,
    showOverflow: 'title',
    slots: {
      default: ({ row }, h) => {
        const rangeScopeOptionMap = getRangeScopeOptionMap.call(vm, row.scope)
        return rangeScopeOptionMap[row[field]]?.label
      },
    },
  }
}

export const getNotifyTypeTableColumn = () => {
  return {
    field: 'notify_type',
    title: i18n.t('common.notify_type'),
    minWidth: 70,
    showOverflow: 'title',
    slots: {
      default: ({ row }, h) => {
        if (row.user_ids) return i18n.t('common.notify_type.receiver')
        if (row.role_ids) return i18n.t('dictionary.role')
        return ''
      },
    },
  }
}

export const getRoleTableColumn = ({ field = 'role_ids', scope } = {}) => {
  return {
    field,
    title: i18n.t('dictionary.role'),
    minWidth: 70,
    showOverflow: 'title',
    slots: {
      default: ({ row }, h) => {
        if (row.role_ids) {
          return row.role_ids.map(v => {
            const get_label = (resp) => {
              return resp.data.name
            }
            return <FetchLabel resource="roles" id={v} version="v1" fetcher={get_label} params={{ scope }} />
          })
        }
        return []
      },
    },
  }
}
